export default "__VITE_ASSET__DEspBBg2__"